import React from 'react';
import { Link } from 'react-router-dom';

import { normalizeUri } from 'pages/Search/utils';

import useStyles from './styles';

interface Props {
    to: string;
    label: string;
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
    active?: boolean;
    className?: string;
}

const RedirectLink: React.FC<Props> = ({ to, label, active = true, onClick, className }) => {
    const { classes, cx } = useStyles();

    return active ? (
        <Link to={normalizeUri(to, { double: true })} className={cx(classes.link, className)} onClick={onClick}>
            {label}
        </Link>
    ) : (
        label
    );
};

export default RedirectLink;
